module.exports = __webpack_public_path__ + "img/home.77554774.png";